import React, { useState,  useCallback } from 'react'
import { FaTachometerAlt, FaUserCog, FaPlus, FaCog, FaBars } from "react-icons/fa";
import { AppColors } from '../css/AppColors';
import '../css/sb-admin-2.min.css'
import {  Collapse, Button } from 'react-bootstrap';
import logo from '../img/logo.png'
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
// import ViewCustomers from '../Screens/ViewCustomers';
import { Link } from 'react-router-dom';





const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}


const Sidebar = (props) => {

    const forceUpdate = useForceUpdate()
    const history = useHistory()
    const location = useLocation();
    const [show, setShow] = useState(true)
    // const [activeTab, setActiveTab] = useState('Dashboard')
    // const [open, setOpen] = useState(false)


    function checkRoute(routes) {
        var res;
        for (let key in routes) {
            if (routes[key] == location.pathname) {
                res = true
            }
        }

        return res


    }


    const [tabs, setTabs] = useState([
        {
            tab: 'Customers', active: checkRoute(['/addCustomer', '/viewCustomers']), icon: FaUserCog,
            subTabs: [
                { name: 'Add Customer', route: '/addCustomer' },
                { name: 'View Customer', route: '/viewCustomers' },
            ]

        },
        {
            tab: 'Presciptions', active: checkRoute(['/addPresciption', '/managePrescription']), icon: FaCog,
            subTabs: [
                { name: 'Add Prescription', route: '/addPresciption' },
                { name: 'View Prescriptions', route: '/managePrescription' }
            ]
        },
        {
            tab: 'Orders', active: checkRoute(['/addOrder', '/viewOrder']), icon: FaPlus,
            subTabs: [
                { name: 'Add Order', route: '/addOrder' },
                { name: 'View Order', route: '/viewOrder' }
            ]
        },
        {
            tab: 'Products', active: checkRoute(['/addProduct', '/viewProducts']), icon: FaCog,
            subTabs: [
                { name: 'Add Product', route: '/addProduct' },
                { name: 'View Product', route: '/viewProducts' }
            ]
        },
        {
            tab: 'Manufacturs', active: checkRoute(['/addManufactur', '/viewManufactur']), icon: FaCog,
            subTabs: [
                { name: 'Add Manufactur', route: '/addManufactur' },
                { name: 'View Manufactur', route: '/viewManufactur' }
            ]
        },

        {
            tab: 'Promotions', active: checkRoute(['/addPromotion', '/managePromotion']), icon: FaCog,
            subTabs: [
                { name: 'Add Promotion', route: '/addPromotion' },
                { name: 'View Promotions', route: '/managePromotion' }
            ]
        },

        {
            tab: 'Product Ages', active: checkRoute(['/addProdExpiry', '/viewExpiries']), icon: FaCog,
            subTabs: [
                { name: 'Add Product Age', route: '/addProdExpiry' },
                { name: 'View Product Age', route: '/viewExpiries' }
            ]
        },
    ])

    const RenderTabs = () => (
        <div>
            {
                tabs.map((v, i) => {
                    var Icon = v.icon
                    return <div>
                        <Button
                            onClick={() => {
                                v.active = !v.active
                                forceUpdate()
                                // setOpen(!open)
                            }}
                            aria-controls="example-collapse-text"
                            // aria-expanded={open}
                            variant="outline-none"
                            className="rBBtn"
                        >
                            <Icon color="white" />
                            <span style={{ marginLeft: 10, color: 'white', fontFamily: "RSBo", fontSize: 14 }} >{v.tab}</span>
                            {/* <FaPlus />
                    Manage Customers */}
                        </Button>


                        <div style={{ width: "100%", marginBottom: 10, textAlign: 'center', alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Collapse
                                in={v.active}>
                                <div className="pl-2 " style={{ backgroundColor: 'white', borderRadius: 10, width: "80%", marginTop: 5 }} >
                                    {v.subTabs.map((sV) => {
                                        return (

                                            <li className="nav-item" style={{}}>
                                                {/* <a
                                                    onClick={() => {
                                                        // props.onClickTab('AddCust')
                                                        // setActiveTab('addOrder')
                                                        history.replace('addOrder')

                                                    }}
                                                    className="nav-link"
                                                    style={{ padding: 0, marginTop: 10 }}
                                                    href="#!"
                                                > */}
                                                <Link
                                                    className="nav-link"
                                                    style={{ width: "100%", marginTop: 10, marginLeft: 10, marginBottom: 10, padding: 0, height: 20 }}
                                                    to={sV.route}>
                                                    <span
                                                        className={checkRoute([sV.route]) ? "aTab" : "iATab"}
                                                        style={{ color: checkRoute([sV.route]) ? AppColors.primary : "#222222" }} >{sV.name}</span>
                                                </Link>
                                                {/* </a> */}
                                                {/* <a
                                                    href="#!"
                                                    onClick={() => {
                                                        // props.onClickTab('ViewCust')
                                                        history.replace('viewOrder')
                                                        setActiveTab('viewOrder')

                                                    }}
                                                    style={{ padding: 0, marginTop: 10 }}
                                                    className="nav-link"
                                                >
                                                    <span
                                                        className={location.pathname == "/viewOrder" ? "aTab" : "iATab"}
                                                        style={{ color: location.pathname == "/viewOrder" ? AppColors.primary : "#222222" }} >View Orders</span>
                                                </a> */}
                                            </li>

                                        )
                                    })}

                                </div>

                            </Collapse>
                        </div>
                        {
                            i != tabs.length - 1 &&
                            <hr className="sidebar-divider my-0" />
                        }



                    </div>
                })
            }
        </div>
    )

    if (!show) {
        return (
            <div style={{ height: window.innerHeight }} >


                <button
                    className="d-none d-sm-block d-md-none"
                    onClick={() => setShow(true)}

                    style={{ borderWidth: 0, width: 30, height: 30, borderRadius: 2, marginTop: 10, marginLeft: 10, backgroundColor: AppColors.primary, textAlign: 'center' }}>
                    <FaBars color="white" style={{ marginTop: -3 }} />
                </button>
            </div>
        )
    }

    return (
        <div className id="sidebar">

            <ul
                className="navbar-nav sidebar sidebar-dark "
                style={{ backgroundColor: AppColors.primary }}
                id="accordionSidebar"
            >
                <button
                    className="d-none d-sm-block d-md-none"

                    onClick={() => setShow(false)}
                    style={{ borderWidth: 0, width: 30, height: 30, borderRadius: 2, marginTop: 10, marginLeft: 10, backgroundColor: 'white', textAlign: 'center' }}>
                    <FaBars style={{ marginTop: -3 }} />
                </button>
                {/* Sidebar - Brand */}
                <a
                    className="sidebar-brand d-flex align-items-center justify-content-center"

                >
                    <img src={logo} style={{ width: 170 }} />

                </a>



                {/* Divider */}
                <hr className="sidebar-divider my-0" />
                {/* Nav Item - Dashboard */}
                <li className="nav-item">

                    <a className="nav-link"
                        href="#!"
                        onClick={() => {
                            // props.onClickTab('Dashboard')
                            history.replace('dashboard')
                            // setActiveTab('Dashboard'
                            // )
                        }}
                    >
                        <FaTachometerAlt />
                        <span
                            className={location.pathname == "/dashboard" ? "aTab" : "iATab"}
                            style={{ color: 'white', marginLeft: 10, }} >Dashboard</span>
                    </a>
                </li>
                {/* Divider */}
                <hr className="sidebar-divider my-0" />
                <RenderTabs />
                {/* <li className="nav-item">
                    <a
                        className="nav-link collapsed"
                        aria-expanded="true"
                    >
                        <FaUserCog />
                        <span style={{ marginLeft: 10, color: 'white', fontFamily: location.pathname == "/viewCustomers" || location.pathname == "/addCustomer" ? "RBo" : "RRe" }} >Manage Customers</span>
                    </a>

                </li> */}
                {/* <div className="pl-2" style={{ backgroundColor: 'white', borderRadius: 10, width: "80%", alignSelf: 'center', }} >
                    <li className="nav-item" style={{}} >
                        
                        <a
                            onClick={() => {
                                // props.onClickTab('AddCust')
                                setActiveTab('AddCust')
                                history.replace('addCustomer')

                            }}
                            className="nav-link"
                            style={{ padding: 0, marginTop: 10 }}
                            href="#!"
                        >

                            <span
                                className={location.pathname == "/addCustomer" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/addCustomer" ? AppColors.primary : "#222222" }} >Add Customer</span>
                        </a>
                        <a
                            href="#!"
                            onClick={() => {
                                // props.onClickTab('ViewCust')
                                history.replace('viewCustomers')
                                setActiveTab('ViewCust')

                            }}
                            style={{ padding: 0, marginTop: 10 }}
                            className="nav-link"
                        >
                            <span
                                className={location.pathname == "/viewCustomers" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/viewCustomers" ? AppColors.primary : "#222222" }} >View Customers</span>
                        </a>
                    </li>
                </div> */}
                {/* Divider */}
                {/* <hr className="sidebar-divider my-0" /> */}
                {/* <li className="nav-item">
                    <a
                        className="nav-link collapsed"
                        href="#"

                    >
                        <FaPlus />
                        <span style={{ marginLeft: 10, color: 'white', fontFamily: location.pathname == "/viewOrder" || location.pathname == "/addOrder" ? "RBo" : "RRe" }} >Manage Customers</span>
                    </a>
                </li> */}
                {/* <Button
                    onClick={() => {
                        setOpen(!open)
                    }}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    variant="outline-none"
                    class="rBBtn"
                >
                    <FaPlus color="white" />
                    <span style={{ marginLeft: 10, color: 'white', fontFamily: location.pathname == "/viewOrder" || location.pathname == "/addOrder" ? "RBo" : "RRe", fontSize: 14 }} >Manage Customers</span>
                   
                </Button>
                <Collapse
                    in={open}>
                    <div className="pl-2 " style={{ backgroundColor: 'white', borderRadius: 10, width: "80%", alignSelf: 'center', marginTop: 10 }} >
                        <li className="nav-item" style={{}} >


                            <a
                                onClick={() => {
                                    // props.onClickTab('AddCust')
                                    // setActiveTab('addOrder')
                                    history.replace('addOrder')

                                }}
                                className="nav-link"
                                style={{ padding: 0, marginTop: 10 }}
                                href="#!"
                            >

                                <span
                                    className={location.pathname == "/addOrder" ? "aTab" : "iATab"}
                                    style={{ color: location.pathname == "/addOrder" ? AppColors.primary : "#222222" }} >Add Orders</span>
                            </a>
                            <a
                                href="#!"
                                onClick={() => {
                                    // props.onClickTab('ViewCust')
                                    history.replace('viewOrder')
                                    setActiveTab('viewOrder')

                                }}
                                style={{ padding: 0, marginTop: 10 }}
                                className="nav-link"
                            >
                                <span
                                    className={location.pathname == "/viewOrder" ? "aTab" : "iATab"}
                                    style={{ color: location.pathname == "/viewOrder" ? AppColors.primary : "#222222" }} >View Orders</span>
                            </a>
                        </li>
                    </div>
                </Collapse>

                
                <li className="nav-item">
                    <a
                        className="nav-link collapsed"
                        href="#"
                    >
                        <FaCog />
                        <span style={{ marginLeft: 10, color: 'white', fontFamily: location.pathname == "/viewOrder" || location.pathname == "/addOrder" ? "RBo" : "RRe" }} >Manage Products</span>
                    </a>
                </li> */}

                {/* <div className="pl-2" style={{ backgroundColor: 'white', borderRadius: 10, width: "80%", alignSelf: 'center', }} >
                    <li className="nav-item" style={{}} >
                        <a
                            onClick={() => {
                                // props.onClickTab('AddCust')
                                // setActiveTab('addOrder')
                                history.replace('addProduct')

                            }}
                            className="nav-link"
                            style={{ padding: 0, marginTop: 10 }}
                            href="#!"
                        >

                            <span
                                className={location.pathname == "/addProduct" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/addProduct" ? AppColors.primary : "#222222" }} >Add Product</span>
                        </a>
                        <a
                            href="#!"
                            onClick={() => {
                                // props.onClickTab('ViewCust')
                                history.replace('viewProducts')
                                setActiveTab('viewProducts')

                            }}
                            style={{ padding: 0, marginTop: 10 }}
                            className="nav-link"
                        >
                            <span
                                className={location.pathname == "/viewProducts" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/viewProducts" ? AppColors.primary : "#222222" }} >View Product</span>
                        </a>

                    </li>

                </div> */}
                {/* <li className="nav-item">
                    <a
                        className="nav-link collapsed"
                        aria-expanded="true"
                    >
                        <FaUserCog />
                        <span style={{ marginLeft: 10, color: 'white', fontFamily: location.pathname == "/viewCustomers" || location.pathname == "/addCustomer" ? "RBo" : "RRe" }} >Manage Prescription</span>
                    </a>

                </li> */}
                {/* <div className="pl-2" style={{ backgroundColor: 'white', borderRadius: 10, width: "80%", alignSelf: 'center', }} >
                    <li className="nav-item" style={{}} >

                        <a
                            onClick={() => {
                                // props.onClickTab('AddCust')
                                // setActiveTab('addOrder')
                                history.replace('addPresciption')

                            }}
                            className="nav-link"
                            style={{ padding: 0, marginTop: 10 }}
                            href="#!"
                        >

                            <span
                                className={location.pathname == "/addPresciption" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/addPresciption" ? AppColors.primary : "#222222" }} >Add Prescription</span>
                        </a>
                        <a
                            href="#!"
                            onClick={() => {
                                // props.onClickTab('ViewCust')
                                history.replace('viewProducts')
                                setActiveTab('viewProducts')

                            }}
                            style={{ padding: 0, marginTop: 10 }}
                            className="nav-link"
                        >
                            <span
                                className={location.pathname == "/viewProducts" ? "aTab" : "iATab"}
                                style={{ color: location.pathname == "/viewProducts" ? AppColors.primary : "#222222" }} >View Prescription</span>
                        </a>

                    </li>

                </div> */}
                {/* Divider */}
                {/* Divider */}
                {/* <hr class="sidebar-divider my-0">

<li class="nav-item active">
  <a class="nav-link" href="lst_vehicles.php">
    <i class="fas fa-fw fa-tachometer-alt"></i>
    <span>Manage Vehicles</span></a>
</li>

<!-- Divider 

<hr class="sidebar-divider"> */}
                {/* Heading */}
                {/*<div class="sidebar-heading">
  Interface
</div>*/}
                {/* Nav Item - Pages Collapse Menu */}
                {/*<li class="nav-item">
  <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
    <i class="fas fa-fw fa-cog"></i>
    <span>Components</span>
  </a>
  <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
    <div class="bg-white py-2 collapse-inner rounded">
      <h6 class="collapse-header">Custom Components:</h6>
      <a class="collapse-item" href="buttons.html">Buttons</a>
      <a class="collapse-item" href="cards.html">Cards</a>
    </div>
  </div>
</li>*/}
                {/* Nav Item - Utilities Collapse Menu */}
                {/* <li class="nav-item">
  <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
    <i class="fas fa-fw fa-wrench"></i>
    <span>Utilities</span>
  </a>
  <div id="collapseUtilities" class="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
    <div class="bg-white py-2 collapse-inner rounded">
      <h6 class="collapse-header">Custom Utilities:</h6>
      <a class="collapse-item" href="utilities-color.html">Colors</a>
      <a class="collapse-item" href="utilities-border.html">Borders</a>
      <a class="collapse-item" href="utilities-animation.html">Animations</a>
      <a class="collapse-item" href="utilities-other.html">Other</a>
    </div>
  </div>
</li>*/}
                {/* Divider 
<hr class="sidebar-divider"> */}
                {/* Heading */}
                {/*<div class="sidebar-heading">
  Addons
</div>

<!-- Nav Item - Pages Collapse Menu */}
                {/*<li class="nav-item">
  <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true" aria-controls="collapsePages">
    <i class="fas fa-fw fa-folder"></i>
    <span>Pages</span>
  </a>
  <div id="collapsePages" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
    <div class="bg-white py-2 collapse-inner rounded">
      <h6 class="collapse-header">Login Screens:</h6>
      <a class="collapse-item" href="login.html">Login</a>
      <a class="collapse-item" href="register.html">Register</a>
      <a class="collapse-item" href="forgot-password.html">Forgot Password</a>
      <div class="collapse-divider"></div>
      <h6 class="collapse-header">Other Pages:</h6>
      <a class="collapse-item" href="404.html">404 Page</a>
      <a class="collapse-item" href="blank.html">Blank Page</a>
    </div>
  </div>
</li>*/}
                {/* Nav Item - Charts */}
                {/* <li class="nav-item">
  <a class="nav-link" href="charts.html">
    <i class="fas fa-fw fa-chart-area"></i>
    <span>Charts</span></a>
</li>*/}
                {/* Nav Item - Tables */}
                {/*<li class="nav-item">
  <a class="nav-link" href="tables.html">
    <i class="fas fa-fw fa-table"></i>
    <span>Tables</span></a>
</li>*/}
                {/* Divider */}
                {/* Sidebar Toggler (Sidebar) */}
                {/*<div class="text-center d-none d-md-inline">
  <button class="rounded-circle border-0" id="sidebarToggle"></button>
</div>
*/}
            </ul>
        </div >

    )
}



export default Sidebar
